import { UserInfo } from 'hub-http/userInfo';

export const getUserHasAppGovernanceWriteScope = (
  userInfo?: Partial<UserInfo>
) => {
  return userInfo?.user?.scopes?.includes('app-governance-write');
};
